import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import { frontEndVersion, frontEndCommitHash, backEndStage } from '../../utilities/version';

class SettingsPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{SettingsPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <p>version: {frontEndVersion()}</p>
                        <p>version ID: {frontEndCommitHash()}</p>
                        <p>stage: {backEndStage()}</p>
                    </div>
                </div>
            </div>
        );
    }
}

SettingsPage.meta = {
    label: <FormattedMessage id={'settings'} defaultMessage={'About'} />,
    icon: 'settings',
    action: () => history.push('/settings'),
    locations: ['/settings']
};

export default SettingsPage;



// WEBPACK FOOTER //
// ./src/pages/settings/index.jsx